import React, { FC } from 'react'
import { IInfrastructureProject } from '../../../types/project.types'
import classes from '../infrastructure-tabs/styles.module.scss'
import { useTranslation } from 'react-i18next'
interface IProps {
    data: IInfrastructureProject['additionalFields']
}

const baseTranslationKey = 'projects.infrastructure-projects'

const AdditionalFields: FC<IProps> = ({ data }) => {
    const { t, i18n: { language } } = useTranslation()
    const suffix = language === 'ru' ? 'Ru' : 'Kz'
    if (!data) return null;
    return (
        <div className={classes['field-block']}>
            <div className={classes['field-block__title']}>
                {t(`${baseTranslationKey}.additional-info`)}
            </div>
            <div className={classes['field-row']}>
                {Object.entries(data).map(([key, value]) => {
                    const valueKey = key.startsWith('info') ? `value${suffix}` : `text${suffix}`;
                    const label = key.startsWith('info') ? `label${suffix}` : null;
                    return (
                        <div key={key} className={classes['field-row__item']}>
                            {label && <span className={classes['field-row__label']}>
                                {value[label]}:
                            </span>}
                            <span className={classes['field-row__value']}>{value[valueKey]}</span>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default AdditionalFields